// EXPERIMENT: psf_promote_or_share_qr_code_experiment — remove with experiment cleanup

/**
 * Module-level latch for the QR code experiment's treat and `$exposure`, keyed on the experiment name
 * and never reset. A per-hook ref would reset when the slide-up remounts; a `finally`-released ref or
 * React state would allow a second treat on a reopen. It survives remounts and SPA navigation, so a
 * signer who opens a second petition's slide-up in the same session is not treated or exposed again
 * (enrollment is per session, not per petition). It resets on a full reload.
 */
export const qrCodeTreats = new Map<string, Promise<void>>();
